import type { FederationService as FederationServiceModel } from '@/adapters/catalogv1.g';

export function extractFederationService(model: FederationServiceModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.federation_service_ref ?? '',
    name: model.name ?? '',
    description: model.description ?? '',
    type: model.type ?? '',
    provider: model.provider ?? '',
    issuer: model.issuer ?? '',
    enabled: model.enabled ?? false,
    status: model.status ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogFederationService = ReturnType<
  typeof extractFederationService
>;
